import { MenuItem } from '@material-ui/core';
import React from 'react';
import _ from 'lodash';

import FormSelectRedesign from 'retired/FormSelectRedesign';
import { AffiliationBoardPosition } from 'generated/graphql';

export const AffiliationBoardPositionSelector = ({ ...props }): JSX.Element => {
  const boardPositions = Object.values(AffiliationBoardPosition).map((position) =>
    _.startCase(position)
  );

  return (
    <FormSelectRedesign {...props}>
      {boardPositions.map((position) => (
        <MenuItem key={position} value={position}>
          {position}
        </MenuItem>
      ))}
    </FormSelectRedesign>
  );
};

export default AffiliationBoardPositionSelector;
